const getLogoUrl = (logo) => {
	if (logo) {
		const logoUrl = `${logo.cdnUrl}-/preview/-/resize/40x/`;
		return logoUrl;
	}
	return null;
};

export default getLogoUrl;